export default "__VITE_ASSET__Brz2QVjy__"